import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/lbf/reference/bank_product_type", { offset, filter });
};

export const create = async (data: { name: string; code: string }) => {
  return httpRequest.post("/api/lbf/reference/bank_product_type", data);
};

export const get = async (id: string) => {
  return httpRequest.get(`/api/lbf/reference/bank_product_type/${id}`);
};

export const update = async (id: string, data: { name: string; code: string }) => {
  return httpRequest.put(`/api/lbf/reference/bank_product_type/${id}`, data);
};

export const select = async (data: { query: string; limit: number }) => {
  return httpRequest.get("/api/lbf/reference/bank_product_type/select", data);
};

export const remove = async (id: string) => {
  return httpRequest.del(`/api/lbf/reference/bank_product_type/${id}`);
};
